import { cn } from "@arcadeai/design-system/lib/utils";
import { getToolkitIcon } from "@arcadeai/design-system/metadata/toolkit-icons";
import type { JSX } from "react";

const TOOLKIT_CHIP_LABELS: Record<string, string> = {
  Gmail: "Gmail",
  GoogleCalendar: "Calendar",
  GoogleDrive: "Drive",
  Slack: "Slack",
  Linear: "Linear",
  Github: "GitHub",
};

export function formatChipLabel(service: string): string {
  return TOOLKIT_CHIP_LABELS[service] ?? service;
}

/** Readable list for copy, e.g. "Gmail and Slack". */
export function formatToolkitList(services: string[]): string {
  const labels = services.map(formatChipLabel);
  if (labels.length === 0) {
    return "";
  }
  if (labels.length === 1) {
    return labels[0];
  }
  if (labels.length === 2) {
    return `${labels[0]} and ${labels[1]}`;
  }
  return `${labels.slice(0, -1).join(", ")}, and ${labels.at(-1)}`;
}

type OnboardingToolkitChipsProps = {
  className?: string;
  services: string[];
};

export function OnboardingToolkitChips({
  className,
  services,
}: OnboardingToolkitChipsProps): JSX.Element | null {
  if (services.length === 0) {
    return null;
  }

  return (
    <div className={cn("flex flex-wrap items-center gap-1", className)}>
      {services.map((service) => {
        const Icon = getToolkitIcon(service);
        return (
          <span
            className="flex size-6 shrink-0 items-center justify-center text-muted-foreground"
            key={service}
            title={formatChipLabel(service)}
          >
            <Icon aria-hidden className="size-4" />
            <span className="sr-only">{formatChipLabel(service)}</span>
          </span>
        );
      })}
    </div>
  );
}
